import Vue from 'vue';

Vue.filter('wholeNumber', (value) => {
	if(value === null) return "";
	value += "";
	let s = value.split(".");
	return s[0];
});

Vue.filter('inArray', (needle, haystack) => {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
});

Vue.filter('bluePrintMeasurement',value => {
	value = value + ""; // stringify
	let parts = value.split('.');
	// if no decimals return value
	if(parts.length == 0) return value;
	// find decimal values
	let decimals = "";
	for (var i = 0; i < parts[1].length; i++) {
		if(parts[1].charAt(i) !== "0"){
			decimals += parts[1][i];
		}
	}
	return decimals.length > 0 ? `${parts[0]}.${decimals}` : parts[0];
});

Vue.filter('currency', (value) => {
	if(value === null) value = 0;
	if(isNaN(value)) value = 0;
	let cleaned = String(value).replace(/[^.0-9]/g, '');
	let num = Number.parseFloat(cleaned).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return '$' + String(num);
});

Vue.filter('diffcurrency', (value) => {
	if(value === null) value = 0;
	if(isNaN(value)) value = 0;
	let cleaned = String(value).replace(/[^.0-9]/g, '');
	let num = Number.parseFloat(cleaned).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	let sign = Number(value) < 0 ? "-":"+"; 
	return sign + '$' + String(num);
});

Vue.mixin({
  methods: {
    tryFloat(num) {
      let result = parseFloat(num);
      if(isNaN(result)) {
        return 0;
      }
      return result;
    }
  }
});